var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualifie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 466.1,
    height: 757.339,
    viewBox: "0 0 466.1 757.339",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-736 -161.332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.552,511.159,440,732.183l-1.763,25.156H363.821l-2.68-48.48L339.386,524.1Z",
    transform: "translate(736 161.332)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.865,164.7c1.809-5.582,9.841-7.219,14.651-3.857s6.45,9.96,5.517,15.753-3.974,11-6.957,16.053C277.786,230.4,248.5,337.163,226.205,374.921a47.138,47.138,0,0,0,45.327,3.339,40.479,40.479,0,0,0,72.778-5.675l-10.964,25.277A62.8,62.8,0,0,0,372.894,358.3l-12.007,36.932C386.033,379.621,405,279.864,396.4,248.957a2.634,2.634,0,0,1,1.119-2.94l.034-.022a2.713,2.713,0,0,0,.754-.711c13.637-19.129,8.366-46.288-3.143-66.846-11.6-20.712-28.661-38.136-38.866-59.567C342.747,90.42,341.463,55.461,320.03,32.359c-13.6-14.659-33.577-22.1-53.451-24.308s-39.934.325-59.769,2.854l1.373-3.19c-17.07-12.452-41.9-8.7-59.366,3.189s-29.246,30.256-40.54,48.113L77.24,108.091c-10.133,16.022-49.462,86.522-53.112,105.125S24.956,253.269,40,264.8l5.716-29.707-1.8,1.556c12.776,46.47,12.706,115.223-29.04,139.306A56.856,56.856,0,0,0,68.16,363.573L41.437,393.461A71.343,71.343,0,0,0,81.86,379.923L61.409,404.174l54.622-28.037-11.362,28.8,68.3-12.822",
    transform: "translate(736 161.332)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.125,698.862l-12.591,58.31H363.351l-9.209-30.931Z",
    transform: "translate(736 161.332)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.159,654.991.04,698.254S-2.6,757.173,35.159,757.173s93.6-110.409,93.6-110.409L89.485,547.422,26.176,531.872l8.982,123.119Z",
    transform: "translate(736 161.332)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.97,192.128A122.579,122.579,0,1,0,174.4,301.564L190.779,459.1l125.356-94.938s-24.522-34.419-36.758-72.511a122.446,122.446,0,0,0,59.593-99.526Z",
    transform: "translate(736 161.332)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.959,325.287s-44.427,166.6-116.621,19.992L82.917,389.54s6.664,251.012,26.656,286.554c0,0-21.1,33.32,4.443,39.984s12.217-4.443,25.545,6.664,39.984-7.775,39.984-7.775,134.83,51.426,174.6,11.274V559.906s67.532-61.52,111.958-17.093c0,0-8.885-141.055-58.866-172.154s-112.275-45.372-112.275-45.372Z",
    transform: "translate(736 161.332)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.465,401.2,82.917,389.54S3.5,530.04,12.39,550.032s113.289,18.881,113.289,18.881L103.465,401.2Z",
    transform: "translate(736 161.332)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.7,10.905c19.835-2.529,39.9-5.061,59.769-2.854s39.851,9.649,53.451,24.308c21.434,23.1,22.717,58.061,36.267,86.513,10.206,21.431,27.271,38.855,38.866,59.567,11.509,20.558,16.78,47.717,3.143,66.846a2.713,2.713,0,0,1-.754.711h0a2.618,2.618,0,0,0-1.112,2.979c8.817,28.155-3.439,61.666-28.554,77.26L378.783,289.3c-6,18.4-25.153,98.553-43.548,104.559L346.2,368.584a40.479,40.479,0,0,1-72.778,5.675,47.138,47.138,0,0,1-45.327-3.339c22.29-37.758,48.581-140.516,70.871-178.274,2.983-5.053,6.023-10.259,6.957-16.053s-.707-12.391-5.517-15.753-12.842-1.725-14.651,3.857",
    transform: "translate(736 161.332)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.186,349.4,63.595,524.975a69.259,69.259,0,0,1-6.775-4.931L71.258,347.889l14.928,1.51Z",
    transform: "translate(736 161.332)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.184,164.239l-116.621-93.3L86.8,212.921V123.338l97.087-93.49,77.747,7.775Z",
    transform: "translate(736 161.332)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.66,606.752,179.018,724.019a17.7,17.7,0,0,1-23.357-8.938L21.067,413.633A17.7,17.7,0,0,1,30,390.275L292.647,273.008A17.7,17.7,0,0,1,316,281.946L450.6,583.4a17.7,17.7,0,0,1-8.938,23.357Z",
    transform: "translate(736 161.332)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.847,587.043,173.015,685.719a16.663,16.663,0,0,1-21.984-8.412L20.977,405.276a16.663,16.663,0,0,1,8.412-21.985l247.2-110.374a16.663,16.663,0,0,1,21.984,8.413L425.259,565.06a16.663,16.663,0,0,1-8.412,21.984Z",
    transform: "translate(748.715 174.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.463,482.9,72.941,693.216.04,698.254,25.591,480.13c-10.084-10.76-16.117-26.807-15.271-44.465,1.48-30.9,23.408-54.95,48.978-53.725S104.4,409.2,102.915,440.1c-.846,17.658-8.386,33.055-19.452,42.8Z",
    transform: "translate(736 161.332)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H17.28V29s-4.039-8.471-8.359-8.471S0,29,0,29Z",
    transform: "translate(1070.07 762.092) rotate(-7)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H17.281V29s-4.211-5.5-8.531-5.5S0,29,0,29Z",
    transform: "translate(1089.924 759.502) rotate(-41)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.034,385.868h-150a9,9,0,1,1,0-18h150a9,9,0,0,1,0,18Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.034,344.368h-33a9,9,0,1,1,0-18h33a9,9,0,0,1,0,18Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.034,427.368h-150a9,9,0,0,1,0-18h150a9,9,0,0,1,0,18Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.034,468.868h-150a9,9,0,0,1,0-18h150a9,9,0,0,1,0,18Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.811,0A35.811,35.811,0,1,1,0,35.811,35.811,35.811,0,0,1,35.811,0Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 1026.098, 714.082)",
    fill: "#923392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.012,561.045a3.983,3.983,0,0,1-3.186-1.594l-9.77-13.027a3.983,3.983,0,0,1,6.374-4.78l6.392,8.522,16.416-24.624a3.984,3.984,0,1,1,6.629,4.419l-19.54,29.309a3.986,3.986,0,0,1-3.2,1.773Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 356.801, 457.531)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifie);
export default __webpack_public_path__ + "static/media/qualifie.4b10a08d24d3bf1d2ee8462e9d31b0bf.svg";
export { ForwardRef as ReactComponent };